// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file chat/v3/chat_rich_text.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserAttribution } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_rich_text.proto.
 */
export const file_chat_v3_chat_rich_text: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common]);

/**
 * RichText represents a document structure.
 *
 * @generated from message chat.v3.RichText
 */
export type RichText = Message<"chat.v3.RichText"> & {
  /**
   * Required: The document type (typically "doc")
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * Content nodes of the document
   *
   * @generated from field: repeated chat.v3.Node content = 2;
   */
  content: Node[];

  /**
   * Optional document-level attributes based on schema
   *
   * @generated from field: optional chat.v3.DocAttrs attrs = 3;
   */
  attrs: DocAttrs;
};

/**
 * Describes the message chat.v3.RichText.
 * Use `create(RichTextSchema)` to create a new message.
 */
export const RichTextSchema: GenMessage<RichText> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 0);

/**
 * Document level attributes
 *
 * @generated from message chat.v3.DocAttrs
 */
export type DocAttrs = Message<"chat.v3.DocAttrs"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: int64 created_at = 2;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 3;
   */
  updatedAt: bigint;

  /**
   * @generated from field: string version = 4;
   */
  version: string;
};

/**
 * Describes the message chat.v3.DocAttrs.
 * Use `create(DocAttrsSchema)` to create a new message.
 */
export const DocAttrsSchema: GenMessage<DocAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 1);

/**
 * Node represents a node in the ProseMirror document tree
 *
 * @generated from message chat.v3.Node
 */
export type Node = Message<"chat.v3.Node"> & {
  /**
   * Required: Type of node (e.g., "paragraph", "heading", "list_item", etc.)
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * Content of this node (for branch nodes)
   * May be serialized as `[]` if empty
   *
   * @generated from field: repeated chat.v3.Node content = 2;
   */
  content: Node[];

  /**
   * Text content (for leaf/text nodes)
   *
   * @generated from field: optional string text = 3;
   */
  text?: string;

  /**
   * @generated from oneof chat.v3.Node.attrs
   */
  attrs: {
    /**
     * Standard ProseMirror node types
     *
     * @generated from field: chat.v3.HeadingAttrs heading_attrs = 4;
     */
    value: HeadingAttrs;
    case: "headingAttrs";
  } | {
    /**
     * @generated from field: chat.v3.ImageAttrs image_attrs = 5;
     */
    value: ImageAttrs;
    case: "imageAttrs";
  } | {
    /**
     * @generated from field: chat.v3.CodeBlockAttrs code_block_attrs = 6;
     */
    value: CodeBlockAttrs;
    case: "codeBlockAttrs";
  } | {
    /**
     * @generated from field: chat.v3.TableAttrs table_attrs = 7;
     */
    value: TableAttrs;
    case: "tableAttrs";
  } | {
    /**
     * @generated from field: chat.v3.TableCellAttrs table_cell_attrs = 8;
     */
    value: TableCellAttrs;
    case: "tableCellAttrs";
  } | {
    /**
     * @generated from field: chat.v3.ListItemAttrs list_item_attrs = 9;
     */
    value: ListItemAttrs;
    case: "listItemAttrs";
  } | {
    /**
     * @generated from field: chat.v3.BlockquoteAttrs blockquote_attrs = 10;
     */
    value: BlockquoteAttrs;
    case: "blockquoteAttrs";
  } | {
    /**
     * @generated from field: chat.v3.HorizontalRuleAttrs hr_attrs = 11;
     */
    value: HorizontalRuleAttrs;
    case: "hrAttrs";
  } | {
    /**
     * @generated from field: chat.v3.ParagraphAttrs paragraph_attrs = 12;
     */
    value: ParagraphAttrs;
    case: "paragraphAttrs";
  } | {
    /**
     * @generated from field: chat.v3.ListAttrs list_attrs = 13;
     */
    value: ListAttrs;
    case: "listAttrs";
  } | {
    /**
     * Variable node for mustache variables (type = "variable:v1")
     *
     * @generated from field: chat.v3.VariableNodeV1Attrs variable_attrs = 14;
     */
    value: VariableNodeV1Attrs;
    case: "variableAttrs";
  } | {
    /**
     * @generated from field: chat.v3.CitationAttrs citation_attrs = 15;
     */
    value: CitationAttrs;
    case: "citationAttrs";
  } | { case: undefined; value?: undefined };

  /**
   * Optional: Marks applied to this node (for text nodes)
   *
   * @generated from field: repeated chat.v3.Mark marks = 30;
   */
  marks: Mark[];
};

/**
 * Describes the message chat.v3.Node.
 * Use `create(NodeSchema)` to create a new message.
 */
export const NodeSchema: GenMessage<Node> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 2);

/**
 * Mark represents formatting applied to text nodes
 *
 * @generated from message chat.v3.Mark
 */
export type Mark = Message<"chat.v3.Mark"> & {
  /**
   * Required: Type of mark (e.g., "bold", "italic", "link")
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * Optional: Mark attributes based on mark type
   *
   * @generated from oneof chat.v3.Mark.attrs
   */
  attrs: {
    /**
     * @generated from field: chat.v3.LinkAttrs link_attrs = 2;
     */
    value: LinkAttrs;
    case: "linkAttrs";
  } | {
    /**
     * @generated from field: chat.v3.EmAttrs em_attrs = 3;
     */
    value: EmAttrs;
    case: "emAttrs";
  } | {
    /**
     * @generated from field: chat.v3.StrongAttrs strong_attrs = 4;
     */
    value: StrongAttrs;
    case: "strongAttrs";
  } | {
    /**
     * @generated from field: chat.v3.CodeAttrs code_attrs = 5;
     */
    value: CodeAttrs;
    case: "codeAttrs";
  } | {
    /**
     * @generated from field: chat.v3.HighlightAttrs highlight_attrs = 6;
     */
    value: HighlightAttrs;
    case: "highlightAttrs";
  } | {
    /**
     * @generated from field: chat.v3.StrikeAttrs strike_attrs = 7;
     */
    value: StrikeAttrs;
    case: "strikeAttrs";
  } | {
    /**
     * @generated from field: chat.v3.SubscriptAttrs subscript_attrs = 8;
     */
    value: SubscriptAttrs;
    case: "subscriptAttrs";
  } | {
    /**
     * @generated from field: chat.v3.SuperscriptAttrs superscript_attrs = 9;
     */
    value: SuperscriptAttrs;
    case: "superscriptAttrs";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chat.v3.Mark.
 * Use `create(MarkSchema)` to create a new message.
 */
export const MarkSchema: GenMessage<Mark> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 3);

/**
 * Specific attribute message types
 *
 * @generated from message chat.v3.HeadingAttrs
 */
export type HeadingAttrs = Message<"chat.v3.HeadingAttrs"> & {
  /**
   * @generated from field: int32 level = 1;
   */
  level: number;
};

/**
 * Describes the message chat.v3.HeadingAttrs.
 * Use `create(HeadingAttrsSchema)` to create a new message.
 */
export const HeadingAttrsSchema: GenMessage<HeadingAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 4);

/**
 * @generated from message chat.v3.ImageAttrs
 */
export type ImageAttrs = Message<"chat.v3.ImageAttrs"> & {
  /**
   * @generated from field: string src = 1;
   */
  src: string;

  /**
   * @generated from field: optional string alt = 2;
   */
  alt: string;

  /**
   * @generated from field: optional string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional int32 width = 4;
   */
  width: number;

  /**
   * @generated from field: optional int32 height = 5;
   */
  height: number;
};

/**
 * Describes the message chat.v3.ImageAttrs.
 * Use `create(ImageAttrsSchema)` to create a new message.
 */
export const ImageAttrsSchema: GenMessage<ImageAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 5);

/**
 * @generated from message chat.v3.CodeBlockAttrs
 */
export type CodeBlockAttrs = Message<"chat.v3.CodeBlockAttrs"> & {
  /**
   * @generated from field: string language = 1;
   */
  language: string;
};

/**
 * Describes the message chat.v3.CodeBlockAttrs.
 * Use `create(CodeBlockAttrsSchema)` to create a new message.
 */
export const CodeBlockAttrsSchema: GenMessage<CodeBlockAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 6);

/**
 * @generated from message chat.v3.TableAttrs
 */
export type TableAttrs = Message<"chat.v3.TableAttrs"> & {
  /**
   * Number of rows
   *
   * @generated from field: int32 rows = 1;
   */
  rows: number;

  /**
   * Number of columns
   *
   * @generated from field: int32 cols = 2;
   */
  cols: number;

  /**
   * Has header row
   *
   * @generated from field: bool header_row = 3;
   */
  headerRow: boolean;

  /**
   * Table caption
   *
   * @generated from field: optional string caption = 4;
   */
  caption: string;

  /**
   * Overall table alignment
   *
   * @generated from field: optional string alignment = 5;
   */
  alignment: string;
};

/**
 * Describes the message chat.v3.TableAttrs.
 * Use `create(TableAttrsSchema)` to create a new message.
 */
export const TableAttrsSchema: GenMessage<TableAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 7);

/**
 * @generated from message chat.v3.TableCellAttrs
 */
export type TableCellAttrs = Message<"chat.v3.TableCellAttrs"> & {
  /**
   * @generated from field: int32 colspan = 1;
   */
  colspan: number;

  /**
   * @generated from field: int32 rowspan = 2;
   */
  rowspan: number;

  /**
   * "left", "center", "right"
   *
   * @generated from field: optional string alignment = 3;
   */
  alignment: string;
};

/**
 * Describes the message chat.v3.TableCellAttrs.
 * Use `create(TableCellAttrsSchema)` to create a new message.
 */
export const TableCellAttrsSchema: GenMessage<TableCellAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 8);

/**
 * @generated from message chat.v3.ListItemAttrs
 */
export type ListItemAttrs = Message<"chat.v3.ListItemAttrs"> & {
  /**
   * Nesting level for nested lists
   *
   * @generated from field: int32 level = 1;
   */
  level: number;

  /**
   * "bullet", "ordered", "check", etc.
   *
   * @generated from field: optional string list_type = 2;
   */
  listType: string;

  /**
   * For checkbox/task lists
   *
   * @generated from field: optional bool checked = 3;
   */
  checked: boolean;
};

/**
 * Describes the message chat.v3.ListItemAttrs.
 * Use `create(ListItemAttrsSchema)` to create a new message.
 */
export const ListItemAttrsSchema: GenMessage<ListItemAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 9);

/**
 * @generated from message chat.v3.LinkAttrs
 */
export type LinkAttrs = Message<"chat.v3.LinkAttrs"> & {
  /**
   * @generated from field: string href = 1;
   */
  href: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message chat.v3.LinkAttrs.
 * Use `create(LinkAttrsSchema)` to create a new message.
 */
export const LinkAttrsSchema: GenMessage<LinkAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 10);

/**
 * @generated from message chat.v3.EmAttrs
 */
export type EmAttrs = Message<"chat.v3.EmAttrs"> & {
};

/**
 * Describes the message chat.v3.EmAttrs.
 * Use `create(EmAttrsSchema)` to create a new message.
 */
export const EmAttrsSchema: GenMessage<EmAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 11);

/**
 * @generated from message chat.v3.StrongAttrs
 */
export type StrongAttrs = Message<"chat.v3.StrongAttrs"> & {
};

/**
 * Describes the message chat.v3.StrongAttrs.
 * Use `create(StrongAttrsSchema)` to create a new message.
 */
export const StrongAttrsSchema: GenMessage<StrongAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 12);

/**
 * @generated from message chat.v3.StrikeAttrs
 */
export type StrikeAttrs = Message<"chat.v3.StrikeAttrs"> & {
};

/**
 * Describes the message chat.v3.StrikeAttrs.
 * Use `create(StrikeAttrsSchema)` to create a new message.
 */
export const StrikeAttrsSchema: GenMessage<StrikeAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 13);

/**
 * @generated from message chat.v3.SubscriptAttrs
 */
export type SubscriptAttrs = Message<"chat.v3.SubscriptAttrs"> & {
};

/**
 * Describes the message chat.v3.SubscriptAttrs.
 * Use `create(SubscriptAttrsSchema)` to create a new message.
 */
export const SubscriptAttrsSchema: GenMessage<SubscriptAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 14);

/**
 * @generated from message chat.v3.SuperscriptAttrs
 */
export type SuperscriptAttrs = Message<"chat.v3.SuperscriptAttrs"> & {
};

/**
 * Describes the message chat.v3.SuperscriptAttrs.
 * Use `create(SuperscriptAttrsSchema)` to create a new message.
 */
export const SuperscriptAttrsSchema: GenMessage<SuperscriptAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 15);

/**
 * @generated from message chat.v3.CodeAttrs
 */
export type CodeAttrs = Message<"chat.v3.CodeAttrs"> & {
  /**
   * For syntax highlighting in inline code
   *
   * @generated from field: optional string language = 1;
   */
  language: string;
};

/**
 * Describes the message chat.v3.CodeAttrs.
 * Use `create(CodeAttrsSchema)` to create a new message.
 */
export const CodeAttrsSchema: GenMessage<CodeAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 16);

/**
 * @generated from message chat.v3.BlockquoteAttrs
 */
export type BlockquoteAttrs = Message<"chat.v3.BlockquoteAttrs"> & {
  /**
   * Source citation
   *
   * @generated from field: optional string citation = 1;
   */
  citation: string;
};

/**
 * Describes the message chat.v3.BlockquoteAttrs.
 * Use `create(BlockquoteAttrsSchema)` to create a new message.
 */
export const BlockquoteAttrsSchema: GenMessage<BlockquoteAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 17);

/**
 * @generated from message chat.v3.HorizontalRuleAttrs
 */
export type HorizontalRuleAttrs = Message<"chat.v3.HorizontalRuleAttrs"> & {
  /**
   * Visual style indicator
   *
   * @generated from field: optional string style = 1;
   */
  style: string;
};

/**
 * Describes the message chat.v3.HorizontalRuleAttrs.
 * Use `create(HorizontalRuleAttrsSchema)` to create a new message.
 */
export const HorizontalRuleAttrsSchema: GenMessage<HorizontalRuleAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 18);

/**
 * @generated from message chat.v3.ParagraphAttrs
 */
export type ParagraphAttrs = Message<"chat.v3.ParagraphAttrs"> & {
  /**
   * "left", "center", "right", "justify"
   *
   * @generated from field: optional string alignment = 1;
   */
  alignment: string;

  /**
   * CSS class for styling
   *
   * @generated from field: optional string class = 2;
   */
  class: string;
};

/**
 * Describes the message chat.v3.ParagraphAttrs.
 * Use `create(ParagraphAttrsSchema)` to create a new message.
 */
export const ParagraphAttrsSchema: GenMessage<ParagraphAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 19);

/**
 * @generated from message chat.v3.ListAttrs
 */
export type ListAttrs = Message<"chat.v3.ListAttrs"> & {
  /**
   * "bullet", "ordered", "check"
   *
   * @generated from field: string list_type = 1;
   */
  listType: string;

  /**
   * Starting number for ordered lists
   *
   * @generated from field: optional int32 start = 2;
   */
  start: number;
};

/**
 * Describes the message chat.v3.ListAttrs.
 * Use `create(ListAttrsSchema)` to create a new message.
 */
export const ListAttrsSchema: GenMessage<ListAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 20);

/**
 * --- Begin Platform Customizations ---
 *
 * @generated from message chat.v3.HighlightAttrs
 */
export type HighlightAttrs = Message<"chat.v3.HighlightAttrs"> & {
  /**
   * @generated from field: common.v3.UserAttribution user_attribution = 1;
   */
  userAttribution: UserAttribution;
};

/**
 * Describes the message chat.v3.HighlightAttrs.
 * Use `create(HighlightAttrsSchema)` to create a new message.
 */
export const HighlightAttrsSchema: GenMessage<HighlightAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 21);

/**
 * VariableNodeAttrs represents attributes for a mustache variable node
 * Used when Node.type == "variable:v1"
 *
 * @generated from message chat.v3.VariableNodeV1Attrs
 */
export type VariableNodeV1Attrs = Message<"chat.v3.VariableNodeV1Attrs"> & {
  /**
   * The ID of the variable (e.g., asset ID, concept ID, agent ID, skill ID)
   *
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * Text representing the variable when converted to plain text/markdown (displayName for skills)
   *
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * The type of variable: "asset", "concept", "label", "view", "project_knowledge", "agent", "skill"
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * The identifier name (for skills: the registry key like "fact-check")
   *
   * @generated from field: optional string name = 4;
   */
  name: string;
};

/**
 * Describes the message chat.v3.VariableNodeV1Attrs.
 * Use `create(VariableNodeV1AttrsSchema)` to create a new message.
 */
export const VariableNodeV1AttrsSchema: GenMessage<VariableNodeV1Attrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 22);

/**
 * @generated from message chat.v3.CitationAttrs
 */
export type CitationAttrs = Message<"chat.v3.CitationAttrs"> & {
  /**
   * The text inside the <cite> html tag
   *
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message chat.v3.CitationAttrs.
 * Use `create(CitationAttrsSchema)` to create a new message.
 */
export const CitationAttrsSchema: GenMessage<CitationAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 23);

/**
 * MentionData contains the actual data for a mention
 *
 * @generated from message chat.v3.MentionData
 */
export type MentionData = Message<"chat.v3.MentionData"> & {
  /**
   * @generated from oneof chat.v3.MentionData.id
   */
  id: {
    /**
     * @generated from field: string user_id = 1;
     */
    value: string;
    case: "userId";
  } | {
    /**
     * @generated from field: string concept_id = 2;
     */
    value: string;
    case: "conceptId";
  } | {
    /**
     * @generated from field: string label_id = 3;
     */
    value: string;
    case: "labelId";
  } | {
    /**
     * @generated from field: string asset_id = 4;
     */
    value: string;
    case: "assetId";
  } | {
    /**
     * @generated from field: string attachment_id = 5;
     */
    value: string;
    case: "attachmentId";
  } | {
    /**
     * @generated from field: string project_id = 6;
     */
    value: string;
    case: "projectId";
  } | {
    /**
     * @generated from field: string action_id = 7;
     */
    value: string;
    case: "actionId";
  } | {
    /**
     * @generated from field: string artifact_id = 8;
     */
    value: string;
    case: "artifactId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chat.v3.MentionData.
 * Use `create(MentionDataSchema)` to create a new message.
 */
export const MentionDataSchema: GenMessage<MentionData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 24);

/**
 * MentionNodeAttrs represents attributes for a mention node
 *
 * @generated from message chat.v3.MentionNodeAttrs
 */
export type MentionNodeAttrs = Message<"chat.v3.MentionNodeAttrs"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from oneof chat.v3.MentionNodeAttrs.data
   */
  data: {
    /**
     * @generated from field: chat.v3.UserData user_data = 3;
     */
    value: UserData;
    case: "userData";
  } | {
    /**
     * @generated from field: chat.v3.ConceptData concept_data = 4;
     */
    value: ConceptData;
    case: "conceptData";
  } | {
    /**
     * @generated from field: chat.v3.LabelData label_data = 5;
     */
    value: LabelData;
    case: "labelData";
  } | {
    /**
     * @generated from field: chat.v3.FileData file_data = 6;
     */
    value: FileData;
    case: "fileData";
  } | {
    /**
     * @generated from field: chat.v3.ActionData action_data = 7;
     */
    value: ActionData;
    case: "actionData";
  } | {
    /**
     * @generated from field: chat.v3.RelationshipData relationship_data = 8;
     */
    value: RelationshipData;
    case: "relationshipData";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chat.v3.MentionNodeAttrs.
 * Use `create(MentionNodeAttrsSchema)` to create a new message.
 */
export const MentionNodeAttrsSchema: GenMessage<MentionNodeAttrs> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 25);

/**
 * User mention data
 *
 * @generated from message chat.v3.UserData
 */
export type UserData = Message<"chat.v3.UserData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string email = 4;
   */
  email: string;

  /**
   * @generated from field: optional string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: optional string avatar_url = 6;
   */
  avatarUrl: string;

  /**
   * @generated from field: optional string user_role = 7;
   */
  userRole: string;
};

/**
 * Describes the message chat.v3.UserData.
 * Use `create(UserDataSchema)` to create a new message.
 */
export const UserDataSchema: GenMessage<UserData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 26);

/**
 * Concept mention data
 *
 * @generated from message chat.v3.ConceptData
 */
export type ConceptData = Message<"chat.v3.ConceptData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description: string;

  /**
   * @generated from field: optional string icon = 6;
   */
  icon: string;

  /**
   * @generated from field: optional string domain = 7;
   */
  domain: string;
};

/**
 * Describes the message chat.v3.ConceptData.
 * Use `create(ConceptDataSchema)` to create a new message.
 */
export const ConceptDataSchema: GenMessage<ConceptData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 27);

/**
 * Label mention data
 *
 * @generated from message chat.v3.LabelData
 */
export type LabelData = Message<"chat.v3.LabelData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string color = 5;
   */
  color: string;

  /**
   * @generated from field: optional string category = 6;
   */
  category: string;
};

/**
 * Describes the message chat.v3.LabelData.
 * Use `create(LabelDataSchema)` to create a new message.
 */
export const LabelDataSchema: GenMessage<LabelData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 28);

/**
 * File mention data
 *
 * @generated from message chat.v3.FileData
 */
export type FileData = Message<"chat.v3.FileData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string filename = 4;
   */
  filename: string;

  /**
   * @generated from field: optional string mime_type = 5;
   */
  mimeType: string;

  /**
   * @generated from field: optional int64 size_bytes = 6;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional string url = 7;
   */
  url: string;

  /**
   * @generated from field: optional string upload_status = 8;
   */
  uploadStatus: string;
};

/**
 * Describes the message chat.v3.FileData.
 * Use `create(FileDataSchema)` to create a new message.
 */
export const FileDataSchema: GenMessage<FileData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 29);

/**
 * Action mention data
 *
 * @generated from message chat.v3.ActionData
 */
export type ActionData = Message<"chat.v3.ActionData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string action_type = 5;
   */
  actionType: string;

  /**
   * @generated from field: optional string status = 6;
   */
  status: string;

  /**
   * @generated from field: optional string assignee_id = 7;
   */
  assigneeId: string;

  /**
   * @generated from field: optional int64 due_date = 8;
   */
  dueDate: bigint;
};

/**
 * Describes the message chat.v3.ActionData.
 * Use `create(ActionDataSchema)` to create a new message.
 */
export const ActionDataSchema: GenMessage<ActionData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 30);

/**
 * Relationship mention data
 *
 * @generated from message chat.v3.RelationshipData
 */
export type RelationshipData = Message<"chat.v3.RelationshipData"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tenant_id = 3;
   */
  tenantId: string;

  /**
   * @generated from field: optional string source_id = 4;
   */
  sourceId: string;

  /**
   * @generated from field: optional string target_id = 5;
   */
  targetId: string;

  /**
   * @generated from field: optional string relationship_type = 6;
   */
  relationshipType: string;

  /**
   * @generated from field: optional string label = 7;
   */
  label: string;

  /**
   * @generated from field: optional int64 weight = 8;
   */
  weight: bigint;
};

/**
 * Describes the message chat.v3.RelationshipData.
 * Use `create(RelationshipDataSchema)` to create a new message.
 */
export const RelationshipDataSchema: GenMessage<RelationshipData> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_rich_text, 31);

